import axios from 'axios';

import type { CreateSubmissionPayload, CreateTemplatePayload, Template } from '../../@types/types';
import { getRequestAuthPayload } from '../helpers/getRequestAuth';
import { queryClient } from '../utils/queryClient';

export const createTemplate =
  (isTemplate: boolean) =>
  async (data: CreateTemplatePayload | CreateSubmissionPayload): Promise<Pick<Template, 'id'>> => {
    const networkPayload = await getRequestAuthPayload({
      method: 'post',
      url: `${isTemplate ? 'templates' : 'submissions'}`,
      data,
    });

    const response = await axios(networkPayload);

    if (isTemplate) {
      await queryClient.invalidateQueries({ queryKey: ['templates'] });
    } else {
      await queryClient.invalidateQueries({ queryKey: ['submissions'] });
    }
    return response.data;
  };
